import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import ClientCoverageModel from "../../models/client-coverage";

export default class ClientCoverageRepository extends BaseRepository {
  static modelClass = ClientCoverageModel;
  modelName = "client-coverage";
}
